import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { List, Grid, ScrollSync } from "react-virtualized";
import { useState, useEffect } from "react";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import {
  ArrowBack,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Autorenew as AutorenewIcon,
  Delete,
  Done as DoneIcon,
  Create as CreateIcon,
  Close,
} from "@material-ui/icons";
// import ArrowBack from '@material-ui/icons/ArrowBack';
import { CompositionStore } from "modules/composition/CompositionStore";
import ResourceRow from "modules/composition/components/layouts/ResourceRow";

const styles = (theme) => ({
  container: {
    backgroundColor: "#f2f2f2",
    padding: "20px",
    height: "-webkit-fill-available",
    overflowY: "auto" as any,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
  },
  linearProgress: {
    backgroundColor: "unset",
    color: "#ABC200",
    margin: "0 auto",
  },
  table: {
    marginTop: "10px",
  },
  rateTask: {
    border: "0px",
    backgroundColor: "unset",
  },
  rateTaskCell: {
    border: "0px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#212121",
    fontWeight: 500,
  },
  button: {
    padding: "0px",
  },
  taskCellLoader: {
    height: "400px",
    verticalAlign: "middle",
    textAlign: "center" as any,
  },
  link: {
    color: "#000",
    height: "48px",
    padding: "12px",
  },
  header: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "#a1a1a1",
    backgroundColor: "unset",
    whiteSpace: "nowrap" as any,
  },
  task: {
    backgroundColor: "#ffffff",
    width: "100%",
  },
  taskFlex: {
    backgroundColor: "#ffffff",
    width: "100%",
    display: "flex",
  },
  taskCellFlex: {
    padding: "3px 20px",
    height: "50px",
    lineHeight: "17px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#5c5c5c",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    "&:last-child": {
      width: "128px",
    },
  },
  taskCell: {
    padding: "3px 20px",
    height: "50px",
    lineHeight: "17px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#5c5c5c",
    fontWeight: 400,
    "&:last-child": {
      width: "128px",
    },
  },
  taskLink: {
    color: "#41A0FF",
    fontWeight: 700,
  },
  iconMenu: {
    fontSize: 22,
    color: "#757575",
  },
  buttons: { padding: "10px" },
  inputCell: {
    fontFamily: "Roboto",
    // fontWeight: 500,
    // color: '#000000',
    fontSize: "12px",
    padding: "0px",
    marginTop: "10px",
    marginBottom: "1px",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "70px",
    textAlign: "right" as any,
    "&::selection": {
      //  background: '#ABC200'
    },
    "&::after": {
      borderBottom: "1px dashed !important",
    },
  },
});

// @observer
const ResourceContent = (props) => {
  const { classes, _reloadComponent } = props;
  const [loaded, setLoaded] = useState(false);
  const [hasAlternativeCode, setHasAlternativeCode] = useState(false);
  const [pathString, setPathString] = useState("");
  const [btnEdit, setBtnEdit] = useState(false);
  const [resource, setResource] = useState(CompositionStore.resource);
  const [lista, setLista] = useState([]);
  const [columnSize, setColumnSize] = useState([80, 800, 130, 130]);
  const [items, setItems] = useState({});
  const estilo = CompositionStore.benchComposition.data.publicLibrary
    ? { width: "910px" }
    : { width: "770px" };

  useEffect(() => {
    setLoaded(false);
    getResources();
  }, [resource]);

  const getResources = async () => {
    await CompositionStore.getResources(CompositionStore.benchComposition.id);
    let newLista = CompositionStore.resource.map((el) => {
      let dados = [
        el.data.code,
        el.data.description,
        el.data.unity,
        el.data.totalCost,
      ];
      return dados;
    });
    setLista(newLista);
    setLoaded(true);
    if (hasAlternativeCode == false) {
      verifyAlternativeCode();
    }
  };

  const gridRenderer = ({ key, index, isScrolling, IsVisible, style }) => {
    return (
      <TableRow key={key} className={classes.taskFlex} style={style}>
        <ResourceRow
          item={CompositionStore.resource[index]}
          rateTask={CompositionStore.resource[index].id}
          classes={classes}
          btnEdit={btnEdit}
          hasAlternativeCode={hasAlternativeCode}
          alterarBtnEdit={alterarBtnEdit}
          _reloadComponent={_reloadComponent}
          _setLoaded={setLoaded}
        />
      </TableRow>
    );
  };

  const TOP_HEADER = 113;
  let stringPath = "/" + location.pathname.split("/").slice(1, -1).join("/");
  let run = false,
    cont = 0;
  const alterarBtnEdit = () => {
    setBtnEdit(!btnEdit);
  };

  const verifyAlternativeCode = () => {
    for (let i = 0; i < CompositionStore.resource.length; i++) {
      const element = CompositionStore.resource[i];
      if (
        element.data.alternativeCodeComposition ||
        element.data.alternativeCodeItem
      ) {
        setHasAlternativeCode(true);
        break;
      }
    }
  };

  return loaded ? (
    <div className={classes.container}>
      <div className={classes.grid}>
        <div>
          <IconButton className={classes.button}>
            <Link
              to={stringPath}
              className={classes.link}
              onClick={() => (CompositionStore.loading = false)}
            >
              <ArrowBack />
            </Link>
          </IconButton>
        </div>
      </div>
      <Table className={classes.table}>
        <TableHead className={classes.header}>
          <TableRow>
            <TableCell className={classes.taskCell} style={{ width: "110px" }}>
              {i18n.rateLibraries.header.code}
            </TableCell>

            {hasAlternativeCode && (
              <TableCell
                className={classes.taskCell}
                style={{ width: "110px" }}
              >
                {i18n.rateLibraries.header.alternativeCode}
              </TableCell>
            )}
            <TableCell style={estilo}>
              {i18n.rateLibraries.header.description}
            </TableCell>
            <TableCell
              className={classes.taskCell}
              numeric
              style={{ width: "100px" }}
            >
              {i18n.rateLibraries.header.unity}
            </TableCell>
            <TableCell
              className={classes.taskCell}
              numeric
              style={{ width: "135px" }}
            >
              {i18n.rateLibraries.header.totalCost}
            </TableCell>
            {!CompositionStore.benchComposition.data.publicLibrary && ( // Se o banco de composição for uma biblioteca publica ele exibe a colina de edição
              <TableCell
                className={classes.taskCell}
                numeric
                style={{ width: "130px" }}
              />
            )}
          </TableRow>
        </TableHead>
      </Table>
      <List
        width={
          window.innerWidth -
          (document.getElementById("sideMenuBox")!.offsetWidth + 42)
        }
        rowRenderer={gridRenderer}
        height={window.innerHeight - (TOP_HEADER + 50 + 150)}
        rowCount={lista.length}
        rowHeight={50}
      />
    </div>
  ) : (
    <Table className={classes.table}>
      <TableRow
        className={classes.task}
        style={{ width: window.innerWidth - 350 }}
      >
        <TableCell
          colSpan={5}
          className={classes.taskCellLoader}
          style={{ zIndex: 9 }}
        >
          <CircularProgress
            size={96}
            className={classes.linearProgress}
            variant="indeterminate"
          />
        </TableCell>
      </TableRow>
    </Table>
  );
};

export default withStyles(styles)(ResourceContent);



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/ResourceContent.tsx